import { useState } from "react";
import { MessageCircle } from "lucide-react";
import { waLink } from "@/data/site";

export const ContactForm = ({ dark = true }) => {
  const [form, setForm] = useState({ nome: "", email: "", telefone: "", mensagem: "" });

  const onChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const onSubmit = (e) => {
    e.preventDefault();
    const msg = `Olá! Meu nome é ${form.nome || "(não informado)"}.
Telefone: ${form.telefone || "-"}
E-mail: ${form.email || "-"}
Mensagem: ${form.mensagem || "Preciso de uma desentupidora 24h."}`;
    window.open(waLink(msg), "_blank");
  };

  const inputCls =
    "w-full rounded-md border border-gray-300 bg-white px-4 py-3 text-sm text-brand-black placeholder:text-gray-400 focus:outline-none focus:border-brand-red focus:ring-1 focus:ring-brand-red transition";

  return (
    <form onSubmit={onSubmit} className="bg-white rounded-xl p-6 sm:p-7 shadow-xl" data-testid="contact-form">
      <h3 className="font-display font-extrabold text-xl text-brand-black mb-1">Solicite seu atendimento</h3>
      <p className="text-sm text-gray-500 mb-5">Preencha e fale conosco agora pelo WhatsApp.</p>
      <div className="space-y-3">
        <input name="nome" value={form.nome} onChange={onChange} placeholder="Seu nome" className={inputCls} data-testid="form-nome" required />
        <input name="email" type="email" value={form.email} onChange={onChange} placeholder="Seu e-mail" className={inputCls} data-testid="form-email" />
        <input name="telefone" value={form.telefone} onChange={onChange} placeholder="Seu telefone / WhatsApp" className={inputCls} data-testid="form-telefone" required />
        <textarea name="mensagem" value={form.mensagem} onChange={onChange} placeholder="Como podemos ajudar?" rows={3} className={inputCls} data-testid="form-mensagem" />
      </div>
      <button type="submit" className="btn-green w-full mt-5 text-base" data-testid="form-submit">
        <MessageCircle className="w-5 h-5" /> Chamar no WhatsApp
      </button>
      <p className="text-center text-xs text-gray-400 mt-3">Resposta imediata • Atendimento 24h</p>
    </form>
  );
};
